// extracted by mini-css-extract-plugin
export default {"wrapper":"cA","noPadding":"eA","flavor_wrapper":"fA","flavor_button":"gA","vert":"hA","itemContent":"iA","itemName":"jA","blue":"kA","out_of_stock":"lA","newFlavorBadge":"mA","fullWidth":"nA","flavor_button_selected":"oA","black":"pA","attribute_wrapper":"qA","toggle_wrapper":"rA"};
    if(module.hot) {
      // 1715276856389
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  